<!-- eslint-disable -->
<template>
  <CommonPages id="detail" :class="['detail']" :titlePrefix="movie.title "
    :metaDescription="movie.description || domainConfig?.['meta']?.des || 'Default des'">
    <div class="detail-page">
      <div class="detail-page__content">
        <div class="detail-page__info" :style="movieBackgroundStyle">
          <DetailInfo :movie="movie" @watch="handleWatchTrailer" />
        </div>

        <div v-if="isTrailerOpen" class="detail-page__trailer-modal" @click.self="closeTrailer">
          <div class="detail-page__trailer-dialog">
            <button class="detail-page__trailer-close" type="button" @click="closeTrailer">Close</button>
            <iframe v-if="trailerEmbedUrl" class="detail-page__trailer-frame"
              :src="trailerEmbedUrl" :title="`${movie.title || 'Trailer'} trailer`"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
            <div v-else class="detail-page__trailer-state">
              {{ trailerError || 'Loading trailer...' }}
            </div>
          </div>
        </div>

        <!-- 电视剧剧集展示 -->
        <div v-if="isTv && !isLoading" class="detail-page__episodes">
          <div class="detail-page__episodes-list">
            <div v-for="(episode, index) in episodes" :key="index"
              class="detail-page__episode-item">
              <img class="detail-page__episode-icon" src="@/assets/icon/play-outline.svg" />
              <div class="detail-page__episode-text">Episode {{ episode }}</div>
            </div>
          </div>
          <div class="detail-page__divider"></div>
        </div>

        <div class="detail-page__ads">
          <DownloadAds />
        </div>
        <div class="detail-page__divider"></div>
        <div class="detail-page__reviews" v-show="reviews.length > 0">
          <UserReviews :reviews="reviews" />
        </div>
        <div class="detail-page__divider" v-show="reviews.length > 0"></div>
        <div class="detail-page__posters">
          <Posters :posters="posters" />
        </div>
        <div class="detail-page__divider" v-show="similarMovies.length > 0"></div>

        <div class="detail-page__similar" v-show="similarMovies.length > 0">
          <SimilarMovies :movies="similarMovies" :contentType="isTv ? 'tv' : 'movie'" />
        </div>
      </div>
    </div>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common_no_meta.vue'
import DetailInfo from '@/components/DetailInfo.vue';
import DownloadAds from '@/components/DownloadAdsWrapper.vue';
import UserReviews from '@/components/UserReviews.vue';
import Posters from '@/components/Posters.vue';
import SimilarMovies from '@/components/SimilarMovies.vue';

import '@/css/common.scss';
import '@/css/home.scss';

export default {
  name: 'DetailPage',
  components: {
    CommonPages,
    DetailInfo,
    DownloadAds,
    UserReviews,
    Posters,
    SimilarMovies
  },
  mixins: [common],
  props: {
    channel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isTv: true, // 是否为电视剧类型
      episodes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13], // 剧集列表
      movieId: null,
      isLoading: false, // 添加加载状态
      movie: {
        title: 'Loading...',
        poster: '',
        genres: [],
        score: '0.0',
        imdb: 'IMDb',
        year: '',
        runtime: '',
        description: 'Loading content...',
        director: '',
        writers: '',
        stars: '',
        type: 'movie'
      },
      reviews: [],
      posters: [],
      similarMovies: [],
      trailer: null,
      isTrailerOpen: false,
      isTrailerLoading: false,
      trailerError: '',
      trailerAutoOpened: false,
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
    ]),
    movieBackgroundStyle () {
      return {
        '--bg-image': this.movie.poster ? `url(${this.movie.poster})` : 'none'
      };
    },
    pageTitle () {
      let title;

      if (this.$route.name === 'movieDetail') {
        title = this.domainConfig?.movieDetailTitle || 'Watch {{title}}';
      }
      else if (this.$route.name === 'tvDetail') {
        title = this.domainConfig?.tvDetailTitle || 'Watch {{title}}';
      }
      // 默认标题
      else {
        title = this.domainConfig?.movieDetailTitle || 'Watch {{title}}';
      }

      // 替换siteName占位符
      const siteName = this.domainConfig?.siteName || 'Movie Center';
      title = title.replace(/\{\{siteName\}\}/g, siteName);

      // 如果有title参数，替换占位符
      if (this.movie && title.includes('{{title}}')) {
        const formattedTtitle = this.movie?.title;
        title = title.replace(/\{\{title\}\}/g, formattedTtitle);
      }

      return title;
    },
    pageDescription () {
      let description = 'Want to watch {{title}} online for free? Discover where to stream full episodes on Netflix, Disney+, or Amazon Prime. {{siteName}} gives you updated info on legal and safe viewing options.';

      // if (this.$route.name === 'movieDetail') {
      //   description = this.domainConfig?.movieDetailDescription || 'Watch {{title}}';
      // }
      // else if (this.$route.name === 'tvDetail') {
      //   description = this.domainConfig?.tvDetailDescription || 'Watch {{title}}';
      // }
      // // 默认标题
      // else {
      //   description = this.domainConfig?.movieDetailDescription || 'Want to watch {{title}} online for free? Discover where to stream full episodes on Netflix, Disney+, or Amazon Prime. {{siteName}} gives you updated info on legal and safe viewing options.';
      // }

      // 替换siteName占位符
      const siteName = this.domainConfig?.siteName || 'Movie Center';
      description = description.replace(/\{\{siteName\}\}/g, siteName);

      // 如果有title参数，替换占位符
      if (this.movie && description.includes('{{title}}')) {
        const formattedTtitle = this.movie?.title;
        description = description.replace(/\{\{title\}\}/g, formattedTtitle);
      }

      return description;
    },
    pageKeyword () {
      let keyword = 'Watch {{title}}';

      // 替换siteName占位符
      const siteName = this.domainConfig?.siteName || 'Movie Center';
      keyword = keyword.replace(/\{\{siteName\}\}/g, siteName);

      // 如果有title参数，替换占位符
      if (this.movie && keyword.includes('{{title}}')) {
        const formattedTtitle = this.movie?.title;
        keyword = keyword.replace(/\{\{title\}\}/g, formattedTtitle);
      }

      return keyword;
    },
    trailerEmbedUrl () {
      return this.trailer && this.trailer.key
        ? `https://www.youtube-nocookie.com/embed/${this.trailer.key}?autoplay=1&rel=0`
        : '';
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle,
      meta: [
        {
          name: 'description',
          content: this.pageDescription,
          vmid: 'description'
        },
        {
          name: 'keywords',
          content: this.pageKeyword,
          vmid: 'keywords'
        },
        {
          property: 'og:title',
          content: this.pageTitle,
          vmid: 'og:title'
        },
        {
          property: 'og:description',
          content: this.pageDescription,
          vmid: 'og:description'
        },
      ],
    }
  },
  created () {
    console.log('Detail page created');
    // 从路由参数中获取电影ID和类型
    this.getRouteParams();
    this.loadMovieData();
  },
  mounted () {
    // 设置背景图
    if (this.movie.poster) {
      document.documentElement.style.setProperty('--bg-image', `url(${this.movie.poster})`);
    }
    this.maybeAutoOpenTrailer();
  },
  methods: {
    maybeAutoOpenTrailer () {
      if (this.trailerAutoOpened || this.$route.query.play !== '1') return;
      this.trailerAutoOpened = true;
      this.$nextTick(() => this.handleWatchTrailer());
    },
    handleWatchTrailer () {
      if (this.isTrailerLoading) return;
      if (this.trailer) {
        this.isTrailerOpen = true;
        return;
      }

      const movieId = this.movieId || this.$route.params.movieId;
      if (!movieId) {
        this.trailerError = 'Trailer unavailable.';
        this.isTrailerOpen = true;
        return;
      }

      const endpoint = this.isTv ? `/3/tv/${movieId}/videos` : `/3/movie/${movieId}/videos`;
      this.isTrailerOpen = true;
      this.trailerError = '';
      this.isTrailerLoading = true;

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {},
        url: endpoint,
      })
        .then(response => {
          const trailer = this.selectBestTrailer(response && response.results);
          if (trailer) {
            this.trailer = trailer;
          } else {
            this.trailerError = 'Trailer unavailable.';
          }
          this.isTrailerLoading = false;
        })
        .catch(error => {
          console.error('Trailer 获取失败:', error);
          this.trailerError = 'Trailer unavailable.';
          this.isTrailerLoading = false;
        });
    },
    selectBestTrailer (videos) {
      if (!Array.isArray(videos)) return null;
      const youtubeVideos = videos.filter(video => String(video.site).toLowerCase() === 'youtube' && video.key);
      return youtubeVideos.find(video => video.official && video.type === 'Trailer') ||
        youtubeVideos.find(video => video.type === 'Trailer') ||
        youtubeVideos[0] ||
        null;
    },
    closeTrailer () {
      this.isTrailerOpen = false;
    },
    getRouteParams () {
      // 从路由参数中获取电影ID和类型
      const { movieId, movieName } = this.$route.params;
      console.log(this.$route.params);
      console.log(this.$route.query);

      // 检查路由路径判断是电影还是电视剧
      const isTV = this.$route.path.includes('/tv-shows/');

      console.log('Route params:', { movieId, movieName, isTV });

      if (movieId) {
        this.movieId = movieId;
        this.isTv = isTV;

        // 设置加载状态
        this.isLoading = true;

        // 根据类型调用不同的API
        if (this.isTv) {
          this.fetchTVDetail(movieId);
        } else {
          this.fetchMovieDetail(movieId);
        }
      }
    },

    fetchMovieDetail (movieId) {
      if (!movieId) return;

      this.isLoading = true;

      // 首先获取电影基本信息
      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {},
        url: `/3/movie/${movieId}`,
      })
        .then(response => {
          if (response) {
            console.log('Movie Detail 获取成功:', response);

            // 保存基本信息
            const movieData = response;

            // 获取演员和剧组信息
            this.$global.server.postAPI({
              headers: {
                accept: 'application/json',
                Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
              },
              method: 'get',
              params: {},
              url: `/3/movie/${movieId}/credits`,
            })
              .then(creditsResponse => {
                if (creditsResponse) {
                  console.log('Movie Credits 获取成功:', creditsResponse);

                  // 合并电影信息和演员信息
                  const completeData = {
                    ...movieData,
                    credits: creditsResponse
                  };

                  // 获取电影海报图片
                  this.fetchMovieImages(movieId);

                  // 获取电影评论
                  this.fetchMovieReviews(movieId);

                  // 更新电影数据
                  this.updateMovieData(completeData);
                }
                this.isLoading = false;
              })
              .catch(error => {
                console.error('Movie Credits 获取失败:', error);
                // 即使演员信息获取失败，仍然使用已有的电影基本信息
                this.updateMovieData(movieData);

                // 获取电影海报图片
                this.fetchMovieImages(movieId);

                // 获取电影评论
                this.fetchMovieReviews(movieId);

                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(error => {
          console.error('Movie Detail 失败:', error);
          this.isLoading = false;
        });
    },

    fetchTVDetail (movieId) {
      if (!movieId) return;

      this.isLoading = true;

      // 首先获取电视剧基本信息
      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {},
        url: `/3/tv/${movieId}`,
      })
        .then(response => {
          if (response) {
            console.log('TV Detail 获取成功:', response);

            // 保存基本信息
            const tvData = response;

            // 获取演员和剧组信息
            this.$global.server.postAPI({
              headers: {
                accept: 'application/json',
                Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
              },
              method: 'get',
              params: {},
              url: `/3/tv/${movieId}/credits`,
            })
              .then(creditsResponse => {
                if (creditsResponse) {
                  console.log('TV Credits 获取成功:', creditsResponse);

                  // 合并电视剧信息和演员信息
                  const completeData = {
                    ...tvData,
                    credits: creditsResponse
                  };

                  // 获取电视剧海报图片
                  this.fetchTVImages(movieId);

                  // 获取电视剧评论
                  this.fetchTVReviews(movieId);

                  // 更新电视剧数据
                  this.updateMovieData(completeData, true);

                  // 对于电视剧，设置剧集数量
                  if (tvData.number_of_episodes) {
                    const episodeCount = tvData.number_of_episodes;
                    this.episodes = Array.from({ length: episodeCount }, (_, i) => i + 1);
                  }
                }
                this.isLoading = false;
              })
              .catch(error => {
                console.error('TV Credits 获取失败:', error);
                // 即使演员信息获取失败，仍然使用已有的电视剧基本信息
                this.updateMovieData(tvData, true);

                // 获取电视剧海报图片
                this.fetchTVImages(movieId);

                // 获取电视剧评论
                this.fetchTVReviews(movieId);

                // 对于电视剧，设置剧集数量
                if (tvData.number_of_episodes) {
                  const episodeCount = tvData.number_of_episodes;
                  this.episodes = Array.from({ length: episodeCount }, (_, i) => i + 1);
                }

                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(error => {
          console.error('TV Detail 失败:', error);
          this.isLoading = false;
        });
    },

    // 获取电影海报图片
    fetchMovieImages (movieId) {
      if (!movieId) return;

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {},
        url: `/3/movie/${movieId}/images`,
      })
        .then(response => {
          if (response) {
            console.log('Movie Images 获取成功:', response);

            // 处理海报数据
            this.updatePosterData(response);
          }
        })
        .catch(error => {
          console.error('Movie Images 获取失败:', error);
        });
    },

    // 获取电视剧海报图片
    fetchTVImages (movieId) {
      if (!movieId) return;

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {},
        url: `/3/tv/${movieId}/images`,
      })
        .then(response => {
          if (response) {
            console.log('TV Images 获取成功:', response);

            // 处理海报数据
            this.updatePosterData(response);
          }
        })
        .catch(error => {
          console.error('TV Images 获取失败:', error);
        });
    },

    // 更新海报数据
    updatePosterData (data) {
      if (!data) return;

      // 合并背景图和海报图
      let posterImages = [];

      // 添加背景图
      if (data.backdrops && data.backdrops.length > 0) {
        posterImages = data.backdrops.slice(0, 5).map(item => ({
          image: `https://image.filmzillaxtra.com/t/p/w533_and_h300_bestv2/${item.file_path}`
        }));
      }

      // 添加海报图
      if (data.posters && data.posters.length > 0) {
        const posterItems = data.posters.slice(0, 5).map(item => ({
          image: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face/${item.file_path}`
        }));

        posterImages = [...posterImages, ...posterItems];
      }

      // 更新海报数据
      if (posterImages.length > 0) {
        this.posters = posterImages;
      }
    },

    // 获取电影评论
    fetchMovieReviews (movieId) {
      if (!movieId) return;

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {},
        url: `/3/movie/${movieId}/reviews`,
      })
        .then(response => {
          if (response && response.results) {
            console.log('Movie Reviews 获取成功:', response.results);

            // 处理评论数据
            this.updateReviewsData(response.results);
          }
        })
        .catch(error => {
          console.error('Movie Reviews 获取失败:', error);
        });
    },

    // 获取电视剧评论
    fetchTVReviews (movieId) {
      if (!movieId) return;

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {},
        url: `/3/tv/${movieId}/reviews`,
      })
        .then(response => {
          if (response && response.results) {
            console.log('TV Reviews 获取成功:', response.results);

            // 处理评论数据
            this.updateReviewsData(response.results);
          }
        })
        .catch(error => {
          console.error('TV Reviews 获取失败:', error);
        });
    },

    // 更新评论数据
    updateReviewsData (data) {
      if (!data || !Array.isArray(data) || data.length === 0) return;

      // 处理API返回的评论数据
      const apiReviews = data.map(review => {
        // 检查评论内容的长度，如果超过一定长度，就截断并显示"阅读更多"按钮
        const maxContentLength = 150;
        const needReadMore = review.content && review.content.length > maxContentLength;

        return {
          title: `A review by ${review.author}`,
          author: review.author,
          date: review.created_at ? review.created_at.split('T')[0] : '2025-05-28',
          text: needReadMore
            ? review.content.substring(0, maxContentLength) + '…'
            : review.content,
          showReadMore: needReadMore,
          fullText: review.content
        };
      });

      // 如果API返回的评论数量不够，保留部分默认评论，确保有足够的评论显示
      const minReviewCount = 5;
      if (apiReviews.length >= minReviewCount) {
        this.reviews = apiReviews;
      } else {
        // 保留部分默认评论
        const defaultReviewsToKeep = this.reviews.slice(0, minReviewCount - apiReviews.length);
        this.reviews = [...apiReviews, ...defaultReviewsToKeep];
      }
    },

    updateMovieData (data, isTv = false) {
      if (!data) return;

      // 处理海报路径
      const posterPath = data.poster_path
        ? `https://image.filmzillaxtra.com/t/p/w440_and_h660_face/${data.poster_path}`
        : (data.backdrop_path
          ? `https://image.filmzillaxtra.com/t/p/w440_and_h660_face/${data.backdrop_path}`
          : this.movie.poster);

      // 提取导演信息
      let director = this.movie.director;
      if (data.credits && data.credits.crew) {
        const directorInfo = data.credits.crew.find(person =>
          person.job === 'Director' || person.job === 'Series Director'
        );
        if (directorInfo) {
          director = directorInfo.name;
        }
      }

      // 提取编剧信息
      let writers = this.movie.writers;
      if (data.credits && data.credits.crew) {
        const writingTeam = data.credits.crew.filter(person =>
          person.department === 'Writing' ||
          person.job === 'Writer' ||
          person.job === 'Screenplay' ||
          person.job === 'Story'
        ).slice(0, 2);

        if (writingTeam.length > 0) {
          writers = writingTeam.map(person => person.name).join(', ');
        }
      }

      // 提取演员信息
      let stars = this.movie.stars;
      if (data.credits && data.credits.cast) {
        const mainCast = data.credits.cast.slice(0, 3);
        if (mainCast.length > 0) {
          stars = mainCast.map(person => person.name).join(', ');
        }
      }

      // 更新电影数据
      this.movie = {
        title: data.title || data.name || this.movie.title,
        poster: posterPath,
        genres: data.genres ?
          data.genres.map(genre => genre.name) :
          this.movie.genres,
        score: data.vote_average ? data.vote_average.toFixed(1) : this.movie.score,
        imdb: 'IMDb',
        number_of_episodes: data.number_of_episodes,
        year: data.release_date ?
          data.release_date.split('-')[0] :
          (data.first_air_date ? data.first_air_date.split('-')[0] : this.movie.year),
        runtime: data.runtime ?
          `${Math.floor(data.runtime / 60)}h ${data.runtime % 60}m` :
          (data.episode_run_time && data.episode_run_time.length > 0 ?
            `${Math.floor(data.episode_run_time[0] / 60)}h ${data.episode_run_time[0] % 60}m` :
            this.movie.runtime),
        description: data.overview || this.movie.description,
        director: director,
        writers: writers,
        stars: stars,
        type: isTv ? 'tv' : 'movie'
      };

      // 更新是否为电视剧
      this.isTv = isTv;

      // 设置背景图
      this.updateBackgroundImage(posterPath);

      // 获取相似电影
      this.fetchSimilarContent(data.id, isTv);
    },

    updateBackgroundImage (posterUrl) {
      if (posterUrl) {
        document.documentElement.style.setProperty('--bg-image', `url(${posterUrl})`);
      }
    },

    fetchSimilarContent (id, isTv = false) {
      if (!id) return;

      const endpoint = isTv ? `/3/tv/${id}/similar` : `/3/movie/${id}/similar`;

      this.$global.server.postAPI({
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiIyYzMzNjE2YTRjODNiN2Y2OTgyNDI3Njg5NjhhMGY3MyIsIm5iZiI6MTY4NDMxODgwMC4xNTIsInN1YiI6IjY0NjRhYTUwOWYzN2IwMDE1Y2MzODdlYyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.2meeE8VCa-_Fe1BI1nxliTnFRxIGcPcXdzFfYi0W8Fo'
        },
        method: 'get',
        params: {},
        url: endpoint,
      })
        .then(response => {
          if (response && response.results) {
            console.log('Similar content 获取成功:', response.results);

            // 更新相似电影数据
            this.similarMovies = response.results.slice(0, 10).map(item => ({
              id: item.id, // 保存内容ID
              title: item.title || item.name,
              source: 'TMDB',
              score: item.vote_average.toFixed(1),
              poster: `https://image.filmzillaxtra.com/t/p/w440_and_h660_face/${item.poster_path}`
            }));
          }
        })
        .catch(error => {
          console.error('获取相似内容失败:', error);
        });
    },

    loadMovieData () {
      // 检查是否已通过API加载过数据，如果已加载则不再使用localStorage中的数据
      if (this.movieId) return;

      const storedMovie = localStorage.getItem('selectedMovie');
      if (storedMovie) {
        try {
          const parsedMovie = JSON.parse(storedMovie);

          // 如果存储的数据中有ID，则调用API获取完整信息
          if (parsedMovie.id) {
            this.movieId = parsedMovie.id;
            if (parsedMovie.type === 'tv') {
              this.fetchTVDetail(parsedMovie.id);
            } else {
              this.fetchMovieDetail(parsedMovie.id);
            }
            return;
          }

          // 确保数据格式正确
          this.movie = {
            title: parsedMovie.title || this.movie.title,
            poster: parsedMovie.poster || this.movie.poster,
            genres: Array.isArray(parsedMovie.genres) ? parsedMovie.genres :
              [parsedMovie.genre || ''].filter(g => g !== ''),
            score: parsedMovie.score || this.movie.score,
            imdb: 'IMDb',
            year: parsedMovie.date?.split(' ')[1] || this.movie.year,
            runtime: this.movie.runtime,
            description: parsedMovie.description || this.movie.description,
            director: this.movie.director,
            writers: this.movie.writers,
            stars: this.movie.stars,
            type: parsedMovie.type || this.movie.type
          };

          // 判断是否为电视剧类型
          this.isTv = this.movie.type === 'tv';

          // 如果是电视剧，设置剧集数据
          if (this.isTv) {
            // 剧集数默认为13集，或者从API获取
            const episodeCount = parsedMovie.episodeCount || 13;
            this.episodes = Array.from({ length: episodeCount }, (_, i) => i + 1);
          }

          console.log('Loaded movie data:', this.movie);
        } catch (error) {
          console.error('Error parsing movie data:', error);
        }
      }
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.detail-page {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;

	&__content {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
		gap: rem(44);
	}

	&__info {
		width: 100%;
	}

	&__trailer-modal {
		position: fixed;
		inset: 0;
		z-index: 1000;
		background: rgba(0, 0, 0, 0.82);
		display: flex;
		align-items: center;
		justify-content: center;
		padding: rem(24);
	}

	&__trailer-dialog {
		position: relative;
		width: min(100%, rem(960));
		aspect-ratio: 16 / 9;
		background: #0d0c0f;
		border-radius: rem(16);
		overflow: hidden;
		box-shadow: 0 rem(24) rem(80) rgba(0, 0, 0, 0.5);
	}

	&__trailer-close {
		position: absolute;
		top: rem(12);
		right: rem(12);
		z-index: 1;
		border: 0;
		border-radius: rem(999);
		background: rgba(255, 255, 255, 0.92);
		color: #0d0c0f;
		padding: rem(8) rem(14);
		font-weight: 700;
		cursor: pointer;
	}

	&__trailer-frame,
	&__trailer-state {
		width: 100%;
		height: 100%;
		border: 0;
	}

	&__trailer-state {
		display: flex;
		align-items: center;
		justify-content: center;
		color: #ffffff;
		font-size: rem(18);
		font-weight: 700;
	}

	&__divider {
		height: 1px;
		align-self: stretch;
		opacity: 0.2;
		background: #fff;

		width: calc(100vw - rem(160));
		margin: 0 auto;
	}
	&__ads {
		width: 100%;
	}

	&__reviews {
		width: 100%;
	}

	&__posters {
		width: 100%;
	}

	&__episodes {
		width: 100%;
		padding: 0 rem(80);
	}

	&__section-title {
		color: #ffffff;
		font-size: rem(24);
		line-height: rem(32);
		font-weight: 700;
		margin-bottom: rem(24);
		padding-left: rem(24);
	}

	&__episodes-list {
		display: flex;
		flex-wrap: wrap;
		gap: rem(20);
		width: 100%;
		margin-bottom: rem(44);
	}

	&__episode-item {
		border-radius: rem(16);
		border: 1px solid rgba(255, 255, 255, 0.3);
		padding: rem(16) rem(20);
		display: flex;
		flex-direction: row;
		gap: rem(20);
		align-items: center;
		justify-content: center;
		flex: 0 0 calc((100% - rem(100)) / 6);
		position: relative;
		cursor: pointer;
		transition: background-color 0.2s ease;

		&:hover {
			background-color: rgba(255, 255, 255, 0.1);
		}
	}

	&__episode-icon {
		width: rem(10);
		height: rem(12);
	}

	&__episode-text {
		color: #ffffff;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 700;
	}

	&__similar {
		width: 100%;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.detail-page {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.detail-page {
		// 移动端特定样式
		&__episodes {
			padding: 0 rem(16);
		}

		&__episodes-list {
			gap: rem(16);
		}

		&__episode-item {
			flex: 0 0 calc((100% - rem(16)) / 2);
		}

		&__divider {
			width: calc(100vw - rem(32));
		}
	}
}
</style>
